const DAY_IN_HOURS = 24;
const HOUR_IN_MINUTES = 60;
const MINUTES_IN_SECONDS = 60;
const MILLISECONDS_IN_SECONDS = 1000;
const MILLISECONDS_PER_DAY = DAY_IN_HOURS * HOUR_IN_MINUTES * MINUTES_IN_SECONDS * MILLISECONDS_IN_SECONDS;

export const cookieService = {
	read(name: string): string | undefined {
		if (typeof window === 'undefined') return;
		const cookie = document.cookie.split(';').find((c) => c.split('=')[0].trim() === name);
		return cookie ? cookie.split('=')[1] : undefined;
	},

	write(name: string, value: string, expireInDays?: number, options: CookieOptions = {}) {
		let expires = '';
		if (expireInDays) {
			const d = new Date();
			d.setTime(d.getTime() + MILLISECONDS_PER_DAY * expireInDays);
			expires = 'expires=' + d.toUTCString() + '; ';
		}

		document.cookie = name + '=' + encodeURIComponent(value) + '; ' + expires + cookieAttributes(options);
	},

	remove(name: string, options: CookieOptions = {}) {
		document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; ' + cookieAttributes(options);
	},
};

type CookieOptions = {
	// scope the cookie to the whole site. without it the browser scopes it to the directory of the
	// page that wrote it, which is how the older cookies here have always behaved; switching those
	// would leave their directory-scoped copies shadowing the new one, so it is opt-in per cookie
	siteWide?: boolean;
};

// the same path and domain on write and remove, or the removal lands on a different cookie
function cookieAttributes({ siteWide }: CookieOptions) {
	return (
		(siteWide ? 'path=/; ' : '') +
		'secure; samesite=lax;domain=' +
		document.location.hostname.split('.').slice(-2).join('.')
	);
}
